import { Lazy } from "../lazy";
import { Converter } from "../converter";
import { Logger } from "../../logger/logger";
import { UrlHelper } from "../html/url-helper";

export class LocalStorageManager {
	public static getInstance: () => LocalStorageManager = Lazy.singleton(LocalStorageManager);

	private hasLocalStorage = true;
	constructor() {
		if (!localStorage) {
			this.hasLocalStorage = false;
		}
	}

	public removeItem: (key: string) => boolean = (key) => {
		if (!this.hasLocalStorage) {
			return false;
		}
		localStorage.removeItem(this.keyWithApplicationHash((key)));
		return true;
	}

	public hasItem: (key: string) => boolean = (key) => {
		if (!this.hasLocalStorage) {
			return false;
		}
		let result = localStorage.getItem(this.keyWithApplicationHash(key));
		return result != null && result !== "undefined" && result !== "null";
	}
	public getItem: (key: string) => string = (key) => {
		if (!this.hasLocalStorage) {
			return "";
		}
		return localStorage.getItem(this.keyWithApplicationHash(key));
	}

	public keys: () => string[] = () => {
		let result: string[] = [];
		for (let i = 0, len = localStorage.length; i < len; ++i) {
			let key = localStorage.key(i);
			result.push(key);
		}
		return result;
	}

	public clearCache: () => number = () => {
		if (!this.hasLocalStorage) {
			return -1;
		}

		let oldLength = localStorage.length;
		localStorage.clear();
		return oldLength;
	}

	public clearWithPrefix = (prefix: string) => {
		if (!this.hasLocalStorage) {
			return -1;
		}
		let removedCount = 0;
		for (let key of this.keys()) {
			if (key != null && key.indexOf(prefix) === 0) {
				localStorage.removeItem(key);
				removedCount++;
			}
		}

		return removedCount;
	}

	public getItemFromJson<T>(key: string): T {
		let item = this.getItem(key);
		if (item != null) {
			try {
				let result = JSON.parse(item) as T;
				return result;
			} catch (err) {
				Logger.error(`Could not get key '${key}' from local storage manager`, err);
			}
		}
		return null;
	}

	public setItemToJson<T>(key: string, value: T) {
		this.setItem(key, JSON.stringify(value));
	}

	public setItem: (key: string, data: string) => boolean = (key, data) => {
		if (!this.hasLocalStorage) {
			return false;
		}
		try {
			localStorage.setItem(this.keyWithApplicationHash(key), data);
		} catch (e) {
			Logger.error("Error while setting local storage", e)
		}

		return true;
	}

	private keyWithApplicationHash(key: string) {
		return `${key}_${UrlHelper.getApplicationInstanceHash()}`;
	}
}